module.exports = __webpack_public_path__ + "static/media/kw.d1e76866.svg";